
import appService from '../../services/app';

const state = {
    app: {
        id: '',
        name: '',
        description: '',
        domain: '',
        photo: '',
        email: '',
        phone: '',
        street: '',
        city: '',
        zipcode: ''
    },
};

const getters = {
    app: (state) => state.app,
}

const actions = {
    getAppDetails({ commit }) {
        return appService.getDetails()
            .then((app) => commit('setApp', app))
    },
};

const mutations = {
    setApp(state, app) {
        state.app = app;
    },
};

export const app = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};